import axios from 'axios';

// This two function are agnostic about the baseUrl ending with slash or path starting with it!
export function getBaseUrl() {
  const envBaseUrl = import.meta.env.VITE_BASE_REST_URL;
  // Remove trailing slash from base if exists
  return envBaseUrl.endsWith('/') ? envBaseUrl.slice(0, -1) : envBaseUrl;
}

export function endpoint(path) {
  // Remove leading slash from path if exists
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${getBaseUrl()}/${normalizedPath}`;
}

export function withGetParams(url, getParams) {
  const gets = Object.keys(getParams)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(getParams[key])}`)
    .join('&');
  if (gets !== '') return url + '?' + gets;
  else return url;
}

export async function remoteCreate(useAlerts, url, payload, longobjname, shortobjname, idName = "id") {
  try {
    const res = await axios.post(url, payload, {
      withCredentials: true
    });
    if (res.status !== 201) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    useAlerts.value.successAlert(`New ${longobjname} created!`, `${shortobjname} ID = ${res.data[idName]}`);
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
    throw e;
  }
}

export async function remoteModifyPut(useAlerts, url, payload, longobjname, shortobjname, idName = "id") {
  try {
    const res = await axios.put(url, payload, {
      withCredentials: true
    });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    useAlerts.value.successAlert(`${longobjname} updated!`, `${shortobjname} ID = ${res.data[idName]}`);
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}

export async function remoteModifyPatch(useAlerts, url, payload, longobjname, shortobjname, idName = "id") {
  try {
    const res = await axios.patch(url, payload, {
      withCredentials: true
    });
    if (res.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    useAlerts.value.successAlert(`${longobjname} updated!`, `${shortobjname} ID = ${res.data[idName]}`);
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}

export async function remoteDelete(useAlerts, url, longobjname, shortobjname) {
  try {
    const res = await axios.delete(url, {
      withCredentials: true
    });
    if (res.status !== 204) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${res.status} ${res.data}`);
      return;
    }
    useAlerts.value.successAlert(`${longobjname} deleted successfully!`, `${shortobjname} deleted REST URL = ${url}`);
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${e.response.status}`, `${JSON.stringify(e.response.data)}`);
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(e.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(e.message)}`);
    }
  }
}
